export default __webpack_public_path__ + "static/media/marvel-pipe.f2cd2df5.jpg";